import React from "react";
import StudentTimelineSection from "./StudentTimelineSection";

export default function StudentDetailTimelineCard({
  viewingStudent,
  visitLogs,
  attendanceLogs,
  icons,
  onOpenLog,
}) {
  return (
    <>
      <div className="w-full space-y-1 mb-8">
        <h3 className="text-xl font-bold text-gray-900">사역 타임라인</h3>
      </div>

      <div className="bg-[#F9FAFB]/50 rounded-[2rem] p-6 border border-gray-100 relative overflow-hidden">
        <div className="absolute left-10 top-10 bottom-10 w-0.5 bg-gradient-to-b from-[#354F38]/20 via-gray-100 to-transparent"></div>

        <div className="space-y-8 relative">
          <StudentTimelineSection
            viewingStudent={viewingStudent}
            visitLogs={visitLogs}
            attendanceLogs={attendanceLogs}
            icons={icons}
            onOpenLog={onOpenLog}
          />
        </div>
      </div>
    </>
  );
}
